/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo – neue Leute treffen, chatten, Spaß haben",
      "Telefonnummer fehlerhaft",
      "Get the app",
      "Weiter mit Apple",
      "Weiter mit Facebook",
      "Weiter mit Google",
      "Einloggen",
      "Registrieren",
      "Gib die angezeigten Zeichen in das Feld ein.",
      "Weiter",
      "Zeichen eingeben",
      "Sicherheitscheck",
      "Neu laden",
      "Erstelle ein neues Passwort, das du dir gut merken kannst.",
      "Aktualisieren",
      "Passwort bestätigen",
      "Passwort muss mindestens {{num}} [[characters:num]] haben.",
      "Passwort",
      "Neues Passwort erstellen",
      "Badoo – Blog",
      "Karriere",
      "Chat",
      "Städte",
      "Cookies verwalten",
      "Copyright © 2006 bis heute. Bumble. Alle Rechte vorbehalten.",
      "Apple und das Apple logo sind Marken von Apple Inc.{{__EOL__}}Google Play ist eine Marke von Google LLC.",
      "Jetzt downloaden",
      "Facebook",
      "Wir sind auch hier:",
      "Hilfebereich",
      "Instagram",
      "Sprache",
      "LinkedIn",
      "Übersicht",
      "Badoo ist Teil von Bumble Inc.",
      "Datenschutzrichtlinien",
      "Safety Centre",
      "Sitemap",
      "Erklärung zum Modern Slavery Act",
      "AGB",
      "Twitter",
      "Gib deine E-Mail-Adresse oder Handynummer ein, dann schicken wir dir Anweisungen zum Erstellen eines neuen Passworts.",
      "Neues Passwort anfordern",
      "E-Mail-Adresse oder Handynummer eingeben",
      "Passwort vergessen",
      "Die Models dienen nur zu illustrativen Zwecken.",
      "Jetzt die App holen",
      "Wir freuen uns, unseren Mitgliedern mehr Unterstützung, hilfreiche Technologien und ein sichereres Erlebnis bieten zu können, um mit mehr Zuversicht neue Beziehungen aufbauen zu können. All dies gehört zu unserem Commitment, die App zu sein, die Dating mit Zuversicht ermöglicht – Badoo.",
      "Wir werden auch weiterhin Pionierarbeit leisten, um neue Dating-Technologien zu entwickeln, die auf die Bedürfnisse von Datenden, wie in diesem Bericht beschrieben, abgestimmt sind. Dazu gehört auch der Launch des <b><a href=\"{{url}}\">Täuschungsdetektors™</a></b>, eines Machine-Learning-Modells, das mit einer <b>Genauigkeit von 99,5 Prozent</b> Spam, Betrugsversuche und Fake-Accounts erkennen kann.",
      "Wir werden uns auch weiterhin für die verantwortungsvolle Nutzung von künstlicher Intelligenz (KI) <b>einsetzen</b>, um sicherzustellen, dass menschliche Intelligenz an erster Stelle steht und dass die <b>Authentizität</b> unserer Community durch die Fähigkeiten der KI keinen Schaden erleidet.",
      "Wir werden nicht mehr zu Dating-Trends beitragen, die <b>negative Einstellungen</b> und <b>negatives Verhalten</b> befeuern.",
      "Wir werden daran arbeiten, <b>negatives Verhalten</b> beim Dating zu identifizieren, um die Auswirkungen auf das Wohlergehen unserer Community zu minimieren.",
      "Wir werden nur mit Influencern und Influencerinnen zusammenarbeiten, bei denen wir der Meinung sind, dass sie sich im Internet auf <b>authentische</b> und <b>realistische</b> Weise präsentieren.",
      "Zu Badoo",
      "Unsere Zuversichts-Commitments:",
      "Wir haben diesen Bericht für Datende, Dating-Communitys und Onlineplattformen – für alle – erstellt. Unsere Erkenntnisse sollen dazu beitragen, dass jeder und jede ein positiveres Dating-Erlebnis mit mehr Möglichkeiten als je zuvor haben kann.",
      "Wir bei Badoo wissen, dass noch viel Arbeit vor uns liegt. Unsere Teams haben die Ergebnisse ausgewertet und arbeiten an Änderungen, damit auch wir einen positiven Beitrag leisten können. Zusätzlich haben wir neue Commitments aufgestellt, die wir ab sofort umsetzen möchten.",
      "Wir glauben, dass menschliche Verbindungen so wichtig sind wie nie zuvor. Und dass es wichtiger ist denn je, dass Menschen voller Zuversicht neue Kontakte knüpfen und neue Verbindungen aufbauen können. In diesem entscheidenden Moment haben wir den <b>branchenweit ersten Bericht zum Thema Zuversicht beim Dating</b> erstellt.",
      "Bericht herunterladen",
      "Badoo ist schon immer ein Pionier der Dating-Welt gewesen. Wir haben eine der weltweit ersten Onlinedating-Plattformen geschaffen und als erste Plattform 100 Millionen Downloads erreicht.",
      "Der Bericht führt Verhaltensweisen, Haltungen und Einflüsse auf, die sich in der Vergangenheit negativ aufs Dating ausgewirkt haben. Dazu gibt es Ratschläge von Experten und Expertinnen, wie wir die positiven Aspekte des Datings besser genießen können, und wie wir die Dinge, die wir vermeiden möchten, besser managen (oder ändern) können.",
      "Bewusst daten: entspannt an die Sache herangehen, den Moment genießen und authentisch sein – online und offline",
      "Dazu in der Lage sein, Social-Media-Inhalte zu ignorieren und sich stattdessen darauf zu konzentrieren, was einem selbst guttut",
      "Darauf vertrauen können, dass die Person, die einem gegenübersteht oder mit der man spricht, real ist",
      "Sich der eigenen Absichten sicher sein und darauf vertrauen, dass auch andere ehrlich sagen, wonach sie suchen",
      "Negatives Dating-Verhalten und Paranoia weniger an sich heranlassen",
      "Die folgenden Dinge sind besonders wichtig, um mit Zuversicht zu daten:",
      "Wir glauben, dass dies die größte Hürde in der heutigen Welt des Datings ist, eine Hürde, die wir meistern möchten. Und damit haben wir jetzt begonnen! Statt uns auf Dating-Trends zu konzentrieren, ist unser neues Ziel, für mehr Zuversicht beim Dating zu sorgen. Jedes Jahr werden wir unseren Fortschritt diesbezüglich auswerten. Gleichzeitig werden wir uns auch weiterhin mit den Herausforderungen beschäftigen, vor denen Datende in unserer Branche stehen.",
      "Die Erkenntnisse fließen künftig in jährliche Zuversichts-Commitments und neue Innovationen in unseren Produkten ein, die darauf abzielen, die Zuversicht beim Dating zu verbessern. Unser ultimatives Ziel ist es, Onlinedating rücksichtsvoller, <b><u><a href=\"{{url}}\">sicherer</a></u></b> und wertvoller für alle zu machen, die sich bedeutungsvolle Beziehungen und Kontakte wünschen. Unsere Commitments für 2024 sind unten aufgeführt.",
      "Zu unseren Commitments",
      "Ein Bericht, aus dem zweifelsfrei hervorgeht: Die Zuversicht beim Dating hat bei vielen Singles einen absoluten Tiefstand erreicht.",
      "Bei uns musst du nicht auf einen Volltreffer warten.{{__EOL__}}{{__EOL__}}Geh direkt zu den interessanten Dingen über. Dem eigentlichen Kennenlernen.",
      "Schon bereit zum Chatten?",
      "Mit deiner Registrierung bestätigst du, dass du unseren <a class=\"link\" href=\"{{terms_url}}\">AGB</a>. In unseren <a class=\"link\" href=\"{{privacy_url}}\">Datenschutzrichtlinien</a> erfährst du mehr darüber, wie wir deine Daten verwenden.",
      "Wir helfen dir, mehr von deiner Persönlichkeit zu zeigen,<br />damit du dich beim Daten gut fühlst.",
      "Dating mit Zuversicht.",
      "Oder",
      "Du hast bereits ein Konto?",
      "Registriere dich mit deiner E-Mail-Adresse oder Handynummer",
      "Für deine Wünsche und Erwartungen{{__EOL__}}brauchst du dich nicht zu entschuldigen.",
      "Du möchtest nur ein bisschen chatten? Kein Problem.{{__EOL__}}Bereit für etwas Festes? Wunderbar.{{__EOL__}}{{__EOL__}}Und natürlich kannst du deine Absicht jederzeit ändern.",
      "Hier um zu daten",
      "Bereit für eine Beziehung",
      "Lust zu chatten",
      "Finde Leute, die dasselbe wollen wie du.",
      "{{name}}, {{age}}",
      "Deine Sicherheit steht für uns an erster Stelle.",
      "In unserem Safety Centre findest du Ressourcen, Rat und Unterstützung, um voller Zuversicht zu daten.",
      "Zu unserem Safety Centre",
      "Sicherheit geht vor.<br/>Immer.",
      "Vom ersten Moment an wusste ich, dass aus uns was würde...",
      "Eigentlich wollte ich gar nichts Ernstes...",
      "Ein Rat für alle bei Badoo: Immer authentisch bleiben...",
      "Badoo-Erfolgsgeschichten",
      "Weitere Erfolgsgeschichten ansehen",
      "Bewertet mit__CUT__{{num}}",
      "Apple App Store",
      "Verlass dich auf uns. Seit 2006 haben wir viele, viele Millionen Menschen zusammengebracht.",
      "{{num}} Mio.+__CUT__Downloads",
      "{{num}} Mio.+",
      "Google Play Store",
      "Wir wissen, was wir tun.",
      "Mit E-Mail-Adresse oder Handynummer einloggen",
      "Passwort eingeben",
      "Passwort vergessen?",
      "Registrieren",
      "Noch kein Konto?",
      "Login",
      "Registrieren"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "Zeichen",
                  "Zeichen",
                  "Zeichen",
                  "Zeichen"
            ],
            "singular": [
                  "Zeichen",
                  "Zeichen",
                  "Zeichen",
                  "Zeichen"
            ]
      },
      "day": {
            "plural": [
                  "Tage",
                  "Tage",
                  "Tagen",
                  "Tage"
            ],
            "singular": [
                  "Tag",
                  "Tags",
                  "Tag",
                  "Tag"
            ]
      },
      "hour": {
            "plural": [
                  "Stunden",
                  "Stunden",
                  "Stunden",
                  "Stunden"
            ],
            "singular": [
                  "Stunde",
                  "Stunde",
                  "Stunde",
                  "Stunde"
            ]
      },
      "minute": {
            "plural": [
                  "Minuten",
                  "Minuten",
                  "Minuten",
                  "Minuten"
            ],
            "singular": [
                  "Minute",
                  "Minute",
                  "Minute",
                  "Minute"
            ]
      },
      "month": {
            "plural": [
                  "Monate",
                  "Monate",
                  "Monaten",
                  "Monate"
            ],
            "singular": [
                  "Monat",
                  "Monats",
                  "Monat",
                  "Monat"
            ]
      },
      "second": {
            "plural": [
                  "Sekunden",
                  "Sekunden",
                  "Sekunden",
                  "Sekunden"
            ],
            "singular": [
                  "Sekunde",
                  "Sekunde",
                  "Sekunde",
                  "Sekunde"
            ]
      },
      "year": {
            "plural": [
                  "Jahre",
                  "Jahre",
                  "Jahren",
                  "Jahre"
            ],
            "singular": [
                  "Jahr",
                  "Jahres",
                  "Jahr",
                  "Jahr"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
